"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorPageDescriptionStart = getErrorPageDescriptionStart;
exports.getErrorPageDescriptionEnd = getErrorPageDescriptionEnd;
exports.getSubscriptionPageDescription = getSubscriptionPageDescription;
exports.getPackCountsItem = getPackCountsItem;
exports.getPackCountsTitle = getPackCountsTitle;
exports.getGoodPriceMessage = getGoodPriceMessage;
exports.getFriendlySortingOptionName = getFriendlySortingOptionName;
exports.getFriendlyCategoryFilterName = getFriendlyCategoryFilterName;
exports.getCategoryOptionText = getCategoryOptionText;
exports.getSystemPageOptionText = getSystemPageOptionText;
exports.getIndustryOptionText = getIndustryOptionText;
exports.getTemplatePurposeOptionText = getTemplatePurposeOptionText;
exports.getCustomModulePurposeOptionText = getCustomModulePurposeOptionText;
exports.getCustomModuleCompatibilityOptionText = getCustomModuleCompatibilityOptionText;
exports.getPageLayoutOptionText = getPageLayoutOptionText;
exports.getPurchaseErrorHeaderKey = getPurchaseErrorHeaderKey;
exports.getPurchaseErrorMessageKey = getPurchaseErrorMessageKey;
exports.getCodingTypeOptionOrTitleText = getCodingTypeOptionOrTitleText;
exports.getGoodsPriceOptionOrTitleText = getGoodsPriceOptionOrTitleText;
exports.getGoodSubtypeText = getGoodSubtypeText;
exports.getPackCountsOverflowText = getPackCountsOverflowText;
exports.getManagePurchasesColumnText = getManagePurchasesColumnText;
exports.getManagePurchasesZeroStateText = getManagePurchasesZeroStateText;
exports.getCharactersRemainingText = getCharactersRemainingText;
exports.getDetailsPanelText = getDetailsPanelText;
exports.getManagePurchasesPriceText = getManagePurchasesPriceText;
exports.getPaidViaText = getPaidViaText;
exports.getPaidByText = getPaidByText;
exports.getRefundStatusTagKey = getRefundStatusTagKey;
exports.getRefundStatusButtonKey = getRefundStatusButtonKey;
exports.getFeatureOptionOrTitleText = getFeatureOptionOrTitleText;
exports.getChildTypeOptionOrTitleText = getChildTypeOptionOrTitleText;
exports.getMultiselectFilterOptionOrTitleText = getMultiselectFilterOptionOrTitleText;
exports.getSortedSelectedFilters = getSortedSelectedFilters;
exports.getMultiselectMaxText = getMultiselectMaxText;
exports.getHeaderTabText = getHeaderTabText;
exports.getProviderOptionText = getProviderOptionText;
exports.getPurchasedOnText = getPurchasedOnText;
exports.getUninstallModalHeader = getUninstallModalHeader;
exports.getContentCreateAccessErrorKey = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _CustomWidgetTags = _interopRequireDefault(require("ContentUtils/constants/CustomWidgetTags"));

var _ModuleCompatibilityTagTypes = _interopRequireDefault(require("marketplace-lib/constants/ModuleCompatibilityTagTypes"));

var _CustomModulePurposeOptions = _interopRequireDefault(require("../constants/CustomModulePurposeOptions"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _PayPalPurchaseErrors = _interopRequireDefault(require("../constants/PayPalPurchaseErrors"));

var _ProviderOptions = _interopRequireDefault(require("../constants/ProviderOptions"));

var _StripePurchaseErrors = _interopRequireDefault(require("../constants/StripePurchaseErrors"));

var _UninstallModalTypes = _interopRequireDefault(require("../constants/UninstallModalTypes"));

function getErrorPageDescriptionStart(asset) {
  if (asset.get('connectionType') === 'site_settings_500') {
    return _I18n.default.text('uninstallModal.errorPageDescription.500PageStart');
  } else if (asset.get('connectionType') === 'site_settings_404') {
    return _I18n.default.text('uninstallModal.errorPageDescription.404PageStart');
  } else if (asset.get('connectionType') === 'site_settings_password_prompt') {
    return _I18n.default.text('uninstallModal.errorPageDescription.passwordPromptStart');
  }

  return '';
}

function getErrorPageDescriptionEnd(asset) {
  if (asset.get('type') === 'SITE_SETTINGS') {
    return _I18n.default.text('uninstallModal.errorPageDescription.allDomains');
  }

  return "" + (asset.getIn(['model', 'domain']) || '');
}

function getSubscriptionPageDescription(asset) {
  if (asset.get('connectionType') === 'site_settings_subscription_preferences') {
    return _I18n.default.text('uninstallModal.subscriptionPageDescription.preferences');
  } else if (asset.get('connectionType') === 'site_settings_unsubscribe_backup') {
    return _I18n.default.text('uninstallModal.subscriptionPageDescription.backupUnsubscribe');
  } else if (asset.get('connectionType') === 'site_settings_subscription_confirmation') {
    return _I18n.default.text('uninstallModal.subscriptionPageDescription.updateConfirmation');
  }

  return '';
}

function getPackCountsItem(subType, count) {
  return _I18n.default.text("packCounts." + subType, {
    count: count
  });
}

function getPackCountsTitle(numberOfTemplates) {
  return _I18n.default.text('packCounts.title', {
    numberOfTemplates: numberOfTemplates
  });
}

function getGoodPriceMessage(isFree, goodPrice) {
  return isFree ? _I18n.default.text('goodTile.price.free') : "" + _I18n.default.formatCurrency(goodPrice, {
    unit: '$',
    precision: 0
  });
}

function getFriendlySortingOptionName(sortingFilter) {
  return _I18n.default.text("sortingBar.sortingOptions." + sortingFilter);
}

function getFriendlyCategoryFilterName(goodSubTypeFilter) {
  return _I18n.default.text("sortingBar.goodSubTypeFilterOptions." + goodSubTypeFilter);
}

function getCategoryOptionText(categoryOption) {
  return _I18n.default.text("sidebar.category." + categoryOption);
}

function getSystemPageOptionText(systemPageOption) {
  return _I18n.default.text("header.systemPageOptions." + systemPageOption);
}

function getIndustryOptionText(industryOptionOrTitle) {
  if (industryOptionOrTitle === 'title' || industryOptionOrTitle === 'ALL') {
    return _I18n.default.text("sidebar.industryFilter." + industryOptionOrTitle);
  }

  return _I18n.default.text("tagNames.industryTag." + industryOptionOrTitle);
}

function getTemplatePurposeOptionText(templatePurposeOrTitle) {
  if (templatePurposeOrTitle === 'title' || templatePurposeOrTitle === 'ALL') {
    return _I18n.default.text("sidebar.templatePurposeFilter." + templatePurposeOrTitle);
  }

  return _I18n.default.text("tagNames.templatePurposeTag." + templatePurposeOrTitle);
}

function getCustomModulePurposeOptionText(purposeOptionOrTitle) {
  if (purposeOptionOrTitle === 'title' || purposeOptionOrTitle === 'fullTitle' || purposeOptionOrTitle === _CustomModulePurposeOptions.default.NONE) {
    return _I18n.default.text("sidebar.customModulePurposeFilter." + purposeOptionOrTitle);
  }

  return _I18n.default.text("contentUtils.cmv2Tags." + _CustomWidgetTags.default[purposeOptionOrTitle]);
}

function getCustomModuleCompatibilityOptionText(compatibilityOptionOrTitle) {
  if (compatibilityOptionOrTitle === 'title' || compatibilityOptionOrTitle === _ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY) {
    return _I18n.default.text("sidebar.customModuleCompatibilityFilter." + compatibilityOptionOrTitle);
  }

  return _I18n.default.text("marketplacelib.ModuleCompatibilityTagTypes." + compatibilityOptionOrTitle);
}

function getPageLayoutOptionText(pageLayoutOptionOrTitle) {
  if (pageLayoutOptionOrTitle === 'title' || pageLayoutOptionOrTitle === 'ALL') {
    return _I18n.default.text("sidebar.pageLayoutFilter." + pageLayoutOptionOrTitle);
  }

  return _I18n.default.text("tagNames.layoutTag." + pageLayoutOptionOrTitle);
}

function getPurchaseErrorHeaderKey(purchaseError) {
  var messageKey;

  switch (purchaseError) {
    case _PayPalPurchaseErrors.default.PROVIDER_ERROR:
      {
        messageKey = 'providerErrorHeader';
        break;
      }

    default:
      {
        messageKey = 'header';
        break;
      }
  }

  return "MarketplaceUI.goodDetailsPage.purchaseErrorModal." + messageKey;
}

function getPurchaseErrorMessageKey(purchaseError) {
  var messageKey;

  switch (purchaseError) {
    case _StripePurchaseErrors.default.STRIPE_CHECKOUT_FAILED:
    case _PayPalPurchaseErrors.default.PAYPAL_PURCHASE_FAILED:
      {
        messageKey = 'genericMessage';
        break;
      }

    case _PayPalPurchaseErrors.default.PROVIDER_ERROR:
      {
        messageKey = 'providerErrorMessage';
        break;
      }

    case _StripePurchaseErrors.default.CARD_DECLINED:
      {
        messageKey = 'cardDeclinedMessage';
        break;
      }

    case _StripePurchaseErrors.default.INVALID_NUMBER:
      {
        messageKey = 'invalidNumberMessage';
        break;
      }

    case _StripePurchaseErrors.default.INVALID_EXPIRY_MONTH:
      {
        messageKey = 'invalidExpiryMonthMessage';
        break;
      }

    case _StripePurchaseErrors.default.INVALID_EXPIRY_YEAR:
      {
        messageKey = 'invalidExpiryYearMessage';
        break;
      }

    case _StripePurchaseErrors.default.INVALID_CVC:
      {
        messageKey = 'invalidCvcMessage';
        break;
      }

    case _StripePurchaseErrors.default.INCORRECT_NUMBER:
      {
        messageKey = 'incorrectCardNumberMessage';
        break;
      }

    case _StripePurchaseErrors.default.EXPIRED_CARD:
      {
        messageKey = 'expiredCardMessage';
        break;
      }

    case _StripePurchaseErrors.default.INCORRECT_CVC:
      {
        messageKey = 'incorrectCvcMessage';
        break;
      }

    case _StripePurchaseErrors.default.INCORRECT_ZIP:
      {
        messageKey = 'incorrectZipMessage';
        break;
      }

    case _StripePurchaseErrors.default.PROCESSING_ERROR:
      {
        messageKey = 'processingErrorMessage';
        break;
      }

    default:
      {
        messageKey = 'genericMessage';
        break;
      }
  }

  return "MarketplaceUI.goodDetailsPage.purchaseErrorModal." + messageKey;
}

function getCodingTypeOptionOrTitleText(codingTypeOptionOrTitle) {
  if (codingTypeOptionOrTitle === 'title') {
    return _I18n.default.text("sidebar.codingTypeFilter." + codingTypeOptionOrTitle);
  }

  return _I18n.default.text("tagNames.codingType." + codingTypeOptionOrTitle);
}

function getGoodsPriceOptionOrTitleText(goodsPriceOptionOrTitle) {
  return _I18n.default.text("sidebar.goodsPriceFilter." + goodsPriceOptionOrTitle);
}

function getGoodSubtypeText(goodSubType) {
  return _I18n.default.text("goodSubtype." + goodSubType, {
    defaultValue: ''
  });
}

function getPackCountsOverflowText(packCounts, firstOverflowIndex) {
  var numberOfMoreTemplates = packCounts.slice(firstOverflowIndex).reduce(function (previousTotal, packCount) {
    return previousTotal + packCount.get('count');
  }, 0);
  return _I18n.default.text('packCounts.overflowText', {
    numberOfMoreTemplates: numberOfMoreTemplates
  });
}

function getManagePurchasesColumnText(columnType) {
  return _I18n.default.text("managePurchases.tableColumns." + columnType);
}

function getManagePurchasesZeroStateText(zeroStateType) {
  return _I18n.default.text("managePurchases.zeroState." + zeroStateType);
}

function getCharactersRemainingText(maxCharacters, charactersUsed) {
  var numberOfCharactersRemaining = maxCharacters - charactersUsed;
  return _I18n.default.text('reviewModal.charactersRemaining', {
    numberOfCharactersRemaining: numberOfCharactersRemaining,
    count: numberOfCharactersRemaining
  });
}

function getDetailsPanelText(field) {
  return _I18n.default.text("managePurchases.detailsRow." + field);
}

function getManagePurchasesPriceText(isFree, goodPrice) {
  return isFree ? _I18n.default.text('managePurchases.detailsRow.free') : "$" + goodPrice;
}

function getPaidViaText(paymentType) {
  return _I18n.default.text("managePurchases.detailsRow.paidVia." + paymentType);
}

function getPaidByText(buyerEmail) {
  return _I18n.default.text('managePurchases.detailsRow.paidBy', {
    buyerEmail: buyerEmail
  });
}

function getRefundStatusTagKey(status) {
  return "managePurchases.detailsRow.refundStatusTag." + status;
}

function getRefundStatusButtonKey(status) {
  return "managePurchases.detailsRow.refundStatusButton." + status;
}

function getFeatureOptionOrTitleText(filterOrTitle) {
  if (filterOrTitle === 'NONE' || filterOrTitle === 'fullTitle') {
    return _I18n.default.text("sidebar.COS_TEMPLATE_FEATURES." + filterOrTitle);
  }

  return _I18n.default.text("tagNames.featureTags." + filterOrTitle);
}

function getChildTypeOptionOrTitleText(optionOrTitle) {
  return _I18n.default.text("sidebar.childType." + optionOrTitle);
}

function getMultiselectFilterOptionOrTitleText(filterType, filterOptionOrTitle) {
  if (filterType === _GoodFiltersAndPage.default.CHILD_TYPES) {
    return getChildTypeOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === _GoodFiltersAndPage.default.PRICE) {
    return getGoodsPriceOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === _GoodFiltersAndPage.default.CODING_TYPE) {
    return getCodingTypeOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === _GoodFiltersAndPage.default.FEATURES) {
    return getFeatureOptionOrTitleText(filterOptionOrTitle);
  } else if (filterType === _GoodFiltersAndPage.default.MODULE_COMPATIBILITY) {
    return getCustomModuleCompatibilityOptionText(filterOptionOrTitle);
  } else if (filterType === _GoodFiltersAndPage.default.MODULE_PURPOSE) {
    return getCustomModulePurposeOptionText(filterOptionOrTitle);
  }

  return '';
}

function getSortedSelectedFilters(filterType, selectedFilters) {
  return selectedFilters.sort(function (filter1, filter2) {
    return getMultiselectFilterOptionOrTitleText(filterType, filter1).localeCompare(getMultiselectFilterOptionOrTitleText(filterType, filter2));
  });
}

function getMultiselectMaxText(maxSelections) {
  return _I18n.default.text('MarketplaceUI.directory.sidebar.multiselectDropdownFilter.maxSubtitle', {
    maxSelections: maxSelections
  });
}

function getHeaderTabText(tabId) {
  return _I18n.default.text("header." + tabId);
}

function getProviderOptionText(providerOption) {
  if (providerOption === _ProviderOptions.default.ALL) {
    return _I18n.default.text('sidebar.providerFilter.ALL');
  }

  return providerOption;
}

function getPurchasedOnText(date) {
  var formattedDate = _I18n.default.moment.utc(date).format('ll');

  return _I18n.default.text('managePurchases.detailsRow.purchasedOn', {
    formattedDate: formattedDate
  });
}

function getUninstallModalHeader(modalType) {
  if (modalType === _UninstallModalTypes.default.SEE_WHERE_IN_USE) {
    return _I18n.default.text('uninstallModal.header.SEE_WHERE_IN_USE');
  } else if (modalType === _UninstallModalTypes.default.ATTEMPTED_UNINSTALL_INDIVIDUAL || modalType === _UninstallModalTypes.default.ATTEMPTED_UNINSTALL_PACK) {
    return _I18n.default.text('uninstallModal.header.ATTEMPTED_UNINSTALL');
  }

  return _I18n.default.text('uninstallModal.header.ATTEMPTED_REFUND');
}

var getContentCreateAccessErrorKey = function getContentCreateAccessErrorKey(goodSubType) {
  var contentTypeKey;

  switch (goodSubType) {
    case _GoodSubTypes.default.EMAIL_TEMPLATES:
      {
        contentTypeKey = 'email';
        break;
      }

    case _GoodSubTypes.default.LANDING_PAGES:
      {
        contentTypeKey = 'landingPage';
        break;
      }

    case _GoodSubTypes.default.SITE_PAGES:
      {
        contentTypeKey = 'sitePage';
        break;
      }

    default:
      {
        contentTypeKey = 'default';
        break;
      }
  }

  return "MarketplaceUI.errors.contentCreateAccess." + contentTypeKey;
};

exports.getContentCreateAccessErrorKey = getContentCreateAccessErrorKey;